<script>
export default {
  created() {
    window.location.href = 'https://abudhabi.golog.my/';
  }
}
</script>
